import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ProfessorApiService } from 'src/app/shared/services/professor-api.service';
import { LoginRequest, LoginResponse } from '../models/login.model';

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordService extends ProfessorApiService {
  constructor() {
    super(inject(HttpClient));
  }

  async forgotPassword(payload: LoginRequest): Promise<LoginResponse> {
    const resultado: LoginResponse = await this.makeHttpRequest({
      url: `login?tipo=RECUPERASENHA&CPF=${payload.cpf}&EMAIL=${payload.email}&DATABASE=${payload.local}`,
      method: 'GET',
      body: payload,
    });

    return resultado;
  }
}
